import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { DRAWER_TABS } from '../../../constants';
import { Dialog } from '../../../shared/components';

type RemoveUserDialogProps = {
  open: boolean;
  selectedDrawerTab: DRAWER_TABS;
  removeUser: () => void;
  closeDialog: () => void;
};

const useStyles = makeStyles(() => ({
  dialogContent: {
    color: 'rgba(23, 23, 23, 0.87)',
    '& p': {
      fontSize: '17px',
      marginBottom: '25px',
    },
  },
  dialogActionsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  emailAddess: {
    marginTop: '5px',
  },
}));

export const RemoveUserDialog: React.FC<RemoveUserDialogProps> = ({
  open,
  selectedDrawerTab,
  removeUser,
  closeDialog,
}) => {
  const classes = useStyles();

  const getUserType = () => {
    if (selectedDrawerTab === DRAWER_TABS.ADMINS) {
      return 'admin';
    }
    if (selectedDrawerTab === DRAWER_TABS.CARE_PROVIDERS) {
      return 'care provider';
    }

    return 'patient';
  };

  const getClinicName = () => {
    if (selectedDrawerTab === DRAWER_TABS.ADMINS) {
      return ' your clinic portal';
    }
    return ' Halterix PT +';
  };

  const DialogContent: React.FC = () => {
    return (
      <>
        <Typography>
          {`Are you sure you want to delete this ${getUserType()} account?`}
        </Typography>
        <Typography>
          Care providers should be deleted if you no longer want them to use
          {getClinicName()}. You can invite them to use the app again but their
          existing data will be deleted.
        </Typography>
        <Typography>This action cannot be undone.</Typography>
        <div className={classes.dialogActionsWrapper}>
          <Button onClick={closeDialog} color="primary" variant="outlined">
            Cancel
          </Button>
          <Button onClick={removeUser} color="primary" variant="contained">
            Delete
          </Button>
        </div>
      </>
    );
  };

  return (
    <Dialog
      open={open}
      title={`Remove ${getUserType()}`}
      closeDialog={closeDialog}>
      <div className={classes.dialogContent}>
        <DialogContent />
      </div>
    </Dialog>
  );
};
